import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Link, withRouter } from 'react-router-dom';
import { setupNavigation } from "../../redux/actions/navItemsActions"
import { loadPost } from "../../redux/actions/postCommentActions";
import PostControl from "../postComments/PostControl";
import Spinner from "../common/Spinner";
import UserAvatar from 'react-user-avatar';
import * as apiConfig from "../../api/config";
import { toast } from "react-toastify";
import $ from 'jquery';
import moment from "moment";
import "./PostComment.css"

function PostPage({
    setupNavigation,
    loadPost,
    postId,
    user,
    history,
    ...props
}) {

    const [processing, setProcessing] = useState(true);
    const [errors, setErrors] = useState({});
    const [post, setPost] = useState(null);
    const [itemLink, setItemLink] = useState("/");

    const navigationItems =
    {
        sections: [{}]
    };


    useEffect(() => {
        document.title = "Post | JustGoRide";
      
        if (!post) {
            reloadPost(postId) 
        }
        else {
            setProcessing(false);
        }

    }, [postId]);

    useEffect(() => {
        if (props.location.state && props.location.state.source == "notifications") {
            setProcessing(true);
            reloadPost(postId)
        }
    }, [props.location])

    function reloadPost(postId) {
        loadPost(postId)
            .then((e) => {
                setPost(e)
                setupNavigation(navigationItems);
                switch (e.postType) {
                    case 0:
                        setItemLink(`/user/profile/${e.userReferenceId}`);
                        break;
                    case 1:
                        setItemLink(`/groups/${e.itemReferenceId}`);
                        break;
                    case 2:
                        setItemLink(`/events/${e.itemReferenceId}`);
                        break;
                }
                setProcessing(false);
            })
            .catch(error => {
                if (error.message === "401" || error.message === "404") {
                    history.push("/resourceunavailable");
                    return;
                }
                console.error("Loading routes failed: " + error);
                history.push("/oops");
            });
    }

    function handlePostDeleted() {
        history.push(itemLink);
    }

    function handlePostEdited(editedPost) {
        setPost(editedPost); 
    }

    return (
        processing ?
            <Spinner /> :
            (
                <React.Fragment>
                    <div className="post-banner">
                        <Link to={itemLink}>
                            <div className="post-avatar-container">
                                {post.postType == "1" &&
                                    <React.Fragment>
                                    { post.itemReferenceAvatarAvailable ?
                                        <UserAvatar className="post-avatar" size="75" name={`${post.itemReferenceName}`} src={`${apiConfig.API_URL}groups/avatar/${post.itemReferenceId}.png`} />
                                        :
                                        <div className="post-avatar"><span className="fas fa-users" /></div>
                                    }
                                    </React.Fragment>
                                }
                                {post.postType == "2" &&
                                    <React.Fragment>
                                        { post.itemReferenceAvatarAvailable ?
                                            <UserAvatar className="post-avatar" size="75" name={`${post.itemReferenceName}`} src={`${apiConfig.API_URL}groups/avatar/${post.itemReferenceParentId}.png`} />
                                            :
                                            <div className="post-avatar"><span className="fas fa-users" /></div>
                                        }
                                    <div className="post-avatar-badge"><span className="far fa-calendar-alt"></span></div>
                                    </React.Fragment>
                                }
                            </div>
                            <div className="post-reference-name">
                                <h2>{post.itemReferenceName}</h2>
                            </div>
                        </Link>
                    </div>
                    <div className="row justify-content-center ml-0 mr-0">
                        <div className="post-feed col-8">
                            <PostControl post={post} onPostDeleted={handlePostDeleted} onPostEdited={handlePostEdited} expandComments={true} active={true}/>
                        </div>
                    </div>
                </React.Fragment>
            )

    );

}

PostPage.propTypes = {
    setupNavigation: PropTypes.func.isRequired,
    loadPost: PropTypes.func.isRequired,
    postId: PropTypes.number,
    user: PropTypes.object.isRequired
}


function mapStateToProps(state, ownProps) {
    const id = ownProps.match.params.id;
    return {
        postId: parseInt(id),
        user: state.user
    };
}

const mapDispatchToProps = {
    setupNavigation,
    loadPost
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PostPage)); 


// WEBPACK FOOTER //
// ./src/components/postComments/PostPage.js